// @ts-nocheck
import { HeaderHeightParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = HeaderHeightParameter;
type HandlerType = Handler<Parameter>;

export const dispatchHeaderHeight: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/Header/SetHeaderHeight",
        parameter: props.parameter,
    });
};

export const chain = [dispatchHeaderHeight];

const setHeaderHeight = createHandlerChainRunner(chain, "SetHeaderHeight");
export default setHeaderHeight;
